import styled, { css } from 'styled-components'

const Container = styled.div`
  position: relative;
  padding: 100% 0px 0px;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    padding: 59% 0px 0px;
  }
`

const PlayButtonContainer = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 10%;
  height: 10%;
  visibility: hidden;
  padding: 0;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        width: 20%;
        height: 20%;
      }
    `}

  svg {
    width: 100%;
    height: 100%;
    opacity: 0.5;
    visibility: visible;

    :hover {
      opacity: 0.8;
    }

    ${props =>
      props.playing &&
      css`
        display: none;
        visibility: hidden;
      `}
  }
`

const Video = styled.video`
  width: 100%;
  height: ${props => (props.isInModal ? 'auto' : '100%')};
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: ${props => (props.isInModal ? 'relative' : 'absolute')};
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
`

export { Container, PlayButtonContainer, Video }
